import { Exception } from '../Exception';
export class ItemIsNotSavedException extends Exception {
  constructor() {
    super();
  }
}
